import { g as _createForOfIteratorHelper, _ as _objectSpread2, i as _wrapRegExp, a as _slicedToArray } from './common.js';
import { parse } from 'qs';

/**
 * 쿠키를 가져옵니다.
 * 서버 사이드에서는 null 을 리턴합니다.
 * @param name 쿠키 이름
 * @returns 쿠키 값
 */
function getCookie(name) {
  if (typeof window !== 'undefined') {
    var cookies = (document.cookie || '').split('; ');
    for (var i = 0; i < cookies.length; i += 1) {
      var match = /([^=]+)=(.+)/.exec(cookies[i]);
      if (match && match[1] === name) {
        return match[2];
      }
    }
  }
  return null;
}
/**
 * 쿠키를 설정합니다.
 * @param name 쿠키 이름
 * @param value 쿠키 값
 * @param delay 쿠키 만료 시간
 * @param domain 쿠키 도메인
 */
function setCookie(name, value, delay, domain) {
  var cookieStr = "".concat(name, "=").concat(value, "; path=/; ") + "expires=".concat(new Date(Date.now() + delay).toUTCString(), ";");
  if (domain) {
    cookieStr += " domain=".concat(domain);
  }
  document.cookie = cookieStr;
}

/**
 * app인지 web인지 확인하고, app일 경우 추가로 app의 osType, osVersion도 확인합니다.
 * @param query query
 * @returns app이라면 isApp: true, osType, osVersion을 return. web이라면 isApp: false를 return.
 */
function getDeviceInfo(query) {
  var osType = null;
  var osVersion = null;
  if (typeof window === 'undefined') {
    if (query != null) {
      osType = query.os_type;
      osVersion = query.version;
    }
  } else {
    var search = parse(location.search.slice(1));
    if (search.os_type != null) {
      osType = search.os_type;
      sessionStorage.os_type = search.os_type;
    } else {
      osType = sessionStorage.os_type;
    }
    if (search.os_version != null) {
      osVersion = search.version;
      sessionStorage.os_version = search.version;
    } else {
      osVersion = sessionStorage.os_version;
    }
  }
  if (osVersion == null && osType == null) {
    return {
      isApp: false
    };
  } else {
    return {
      isApp: true,
      osType: osType,
      osVersion: osVersion
    };
  }
}
/**
 * params로 받은 AOS, iOS 버전보다 높은 버전의 app인지 확인합니다.
 * @param AOS 기준 AOS 버전
 * @param iOS 기준 iOS 버전
 * @param query query
 * @returns params로 받은 AOS, iOS 버전보다 높은 버전인 App일 경우 true. Web or MWeb or 기준보다 낮은 버전일 경우 false.
 */
function isHigherAppVersion(_ref) {
  var AOS = _ref.AOS,
    iOS = _ref.iOS,
    query = _ref.query;
  var _getDeviceInfo = getDeviceInfo(query),
    isApp = _getDeviceInfo.isApp,
    osType = _getDeviceInfo.osType,
    osVersion = _getDeviceInfo.osVersion;
  if (!isApp || !osType || !osVersion) return false;
  var targetSelected;
  if (osType === 'Android') {
    targetSelected = AOS;
  } else if (osType === 'iOS') {
    targetSelected = iOS;
  } else {
    return false;
  }
  var currentVersion = /^\d+(\.(\d+))+/.exec(osVersion);
  if (!currentVersion) {
    return false;
  }
  var targetFragments = targetSelected.split('.');
  var versionFragments = currentVersion[0].split('.');
  for (var i = 0; i < targetFragments.length; i += 1) {
    var targetFragment = parseInt(targetFragments[i], 10);
    var versionFragment = parseInt(versionFragments[i], 10);
    if (targetFragment > versionFragment) {
      return false;
    } else if (targetFragment < versionFragment) {
      return true;
    }
  }
  return false;
}
/**
 * 모바일 환경인지 확인합니다.
 * @returns 모바일 환경이라면 true, 아니라면 false 를 리턴합니다.
 */
function isMobile() {
  if (typeof window === 'undefined') return false;
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return true;
  }
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
/**
 * 앱 내에서 실행되는지 확인합니다.
 * 서버사이드에서는 false 를 리턴합니다.
 * @returns 앱 내에서 실행된다면 true, 아니라면 false 를 리턴합니다.
 */
function isInApp() {
  var _a, _b;
  if (typeof window === 'undefined') {
    return false;
  }
  return ['android', 'ios'].includes((_b = (_a = getCookie('bp-p-type')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '');
}

var PRS_CDN_HOST = 'prs.ohousecdn.com';
var IMAGE_CDN_HOST = 'image.ohousecdn.com';
var LOCAL_IMAGE_HOST = 'image.ohou.se';
var LOCAL_SERVICE_BUCKET = 'bucketplace-v2-development';
var ARCHIVED_LEGACY_BUCKETS = ['d224jl0o7z9gbn', 'd12gkpu9h0k5iq'];
var GLOBAL_SERVICE_BUCKETS = ['video-service-prd-s3-bucket-thumbnail', 'oh-image-stage', 'oh-image-ap-northeast-2', 'oh-image-ap-southeast-1', 'oh-image-eu-central-1', 'oh-image-us-east-1', 'oh-image-us-west-2', 'oh-s3-video-qa-thumbnail'];
// Small helper for type inference.
function createImageUrlMatcher(entry) {
  return entry;
}
var MATCHER_RULES = [
// If no src is provided, return empty string.
createImageUrlMatcher({
  test: function test(ctx) {
    return ctx.src === '';
  },
  process: function process(ctx) {
    return ctx.src;
  }
}),
/**
 * `*ohousecdn.com` passes through.
 *
 * E.g., https://image.ohousecdn.com/i/bucketplace-v2-development/156110053885150795.jpeg
 * E.g., https://prs.ohousecdn.com/apne2/any/test/disable-cache/v1-313103641010176.jpg?w=720&q=80
 */
createImageUrlMatcher({
  test: function test(ctx) {
    return /^(?:(?:\w+-)?prs|image)\.ohousecdn\.com/.test(ctx.url.hostname);
  },
  process: function process(ctx) {
    return ctx.url;
  }
}),
/**
 * Rewrites PRS resources to `*prs.ohousecdn.com`.
 *
 * The prefix is optional and can be one of the following:
 * - `qa-`
 * - `dev-`
 *
 * E.g., https://prs.ohou.se/kr/any/examples/v1-141430605185088.jpg
 * E.g., https://prs.ohouse.com/apne2/any/uploads/commerce/event/raffle/v1-175699276497024.png
 */
createImageUrlMatcher({
  locals: {
    envPrefix: undefined
  },
  test: function test(ctx) {
    var _a;
    var matches = /*#__PURE__*/_wrapRegExp(/^(\w+\x2D)?prs\.(?:ohou\.se|ohouse\.com)/, {
      prefix: 1
    }).exec(ctx.url.hostname);
    if (matches == null) {
      return false;
    }
    ctx.locals.envPrefix = (_a = matches.groups) === null || _a === void 0 ? void 0 : _a['prefix'];
    return true;
  },
  process: function process(ctx) {
    var _a;
    var newUrl = new URL(ctx.url);
    // Rewrite the hostname to `*prs.ohousecdn.com`
    newUrl.hostname = "".concat((_a = ctx.locals.envPrefix) !== null && _a !== void 0 ? _a : '').concat(PRS_CDN_HOST);
    return newUrl;
  }
}),
/**
 * Rewrites resources from the image server to `image.ohousecdn.com`.
 *
 * By specifying the bucket name in the path, the CDN will be able to serve
 * exotic resources as well.
 *
 * Both `image.ohou.se` and `image.ohouse.com` are supported through the same
 * host `image.ohousecdn.com`, using the fact that the first part of the path
 * is the bucket name.
 *
 * E.g. https://image.ohou.se/i/bucketplace-v2-development/uploads/productions/164999964262228009.jpg?gif=1&w=640&h=640&c=c&webp=1
 * E.g. https://image.ohouse.com/oh-image-ap-northeast-2/uploads/7510f989-a084-414d-9fff-627aada6c685-1.jpeg?w=256&h=256&c=c&w=72&h=72&q=60
 */
createImageUrlMatcher({
  locals: {
    envPrefix: undefined
  },
  test: function test(ctx) {
    var _a;
    // Handles 'local' image server URLs.
    if (ctx.url.hostname === LOCAL_IMAGE_HOST) {
      return ctx.url.pathname.startsWith('/i/');
    }
    // Handles image server resources hosted on the global service.
    // Note that this will not handle patterns like `qa-image.ohouse.com` which is unsupported by `ohousecdn.com` yet.
    var matches = /*#__PURE__*/_wrapRegExp(/^(\w+\x2D)?image\.ohouse\.com/, {
      prefix: 1
    }).exec(ctx.url.hostname);
    if (matches != null) {
      ctx.locals.envPrefix = (_a = matches.groups) === null || _a === void 0 ? void 0 : _a['prefix'];
      return true;
    }
    return false;
  },
  process: function process(ctx) {
    var newUrl = new URL(ctx.url);
    var envPrefix = ctx.locals.envPrefix;
    newUrl.hostname = envPrefix != null ? "".concat(envPrefix).concat(IMAGE_CDN_HOST) : IMAGE_CDN_HOST;
    return newUrl;
  }
}),
/**
 * Rewrites the global video server thumbnail URLs to corresponding global image server URLs.
 *
 * Such as: /oh-s3-video-{slug}/*
 *
 * E.g., /oh-s3-video-apne2-stage-thumbnail/65685e94888fb53cb1f2e33c/65685e94888fb53cb1f2e33c.0000001.jpg
 */
createImageUrlMatcher({
  test: function test(ctx) {
    return ctx.isRelativeUrl && ctx.url.pathname.startsWith('/oh-s3-video');
  },
  process: function process(ctx) {
    var newUrl = new URL(ctx.url);
    // Although this might not be a reliable way to determine the environment,
    // we are preserving the original code here to avoid breaking the existing
    // behavior.
    var nonProdEnv = ['dev', 'stage', 'qa'].find(function (env) {
      return ctx.url.pathname.includes(env);
    });
    newUrl.hostname = nonProdEnv != null ? "".concat(nonProdEnv, "-").concat(IMAGE_CDN_HOST) : IMAGE_CDN_HOST;
    return newUrl;
  }
}),
/**
 * Rewrites the legacy image server URLs to `image.ohousecdn.com`.
 *
 * The last segment in the paths represents the image size in pixels, which
 * will not be respected during the rewrite. So you might need to reapply the
 * image options if necessary.
 *
 * Such as: /image/(central_crop|resize)/{bucket}/{path..}
 *
 * E.g.,
 * https://image.ohou.se/image/central_crop/bucketplace-v2-development/uploads-users-profile_images-169998132565508046.jpeg/80/80
 */
createImageUrlMatcher({
  locals: {
    bucket: undefined,
    path: undefined
  },
  test: function test(ctx) {
    var _a, _b;
    if (ctx.url.hostname !== LOCAL_IMAGE_HOST) {
      return false;
    }
    // The `path` is encoded with `-` instead of `/`.
    var matches = /*#__PURE__*/_wrapRegExp(/^\/image\/(?:central_crop|resize)\/([^/]+)\/([^/]+)\/.*/, {
      bucket: 1,
      path: 2
    }).exec(ctx.url.pathname);
    if (matches == null || ((_a = matches.groups) === null || _a === void 0 ? void 0 : _a['bucket']) == null || ((_b = matches.groups) === null || _b === void 0 ? void 0 : _b['path']) == null) {
      return false;
    }
    ctx.locals.bucket = matches.groups['bucket'];
    ctx.locals.path = matches.groups['path'];
    return true;
  },
  process: function process(ctx) {
    var newUrl = new URL(ctx.url);
    var _ctx$locals = ctx.locals,
      bucket = _ctx$locals.bucket,
      path = _ctx$locals.path;
    newUrl.hostname = IMAGE_CDN_HOST;
    newUrl.pathname = "/i/".concat(bucket, "/").concat(path.replace(/-/g, '/'));
    return newUrl;
  }
}),
/**
 * Rewrites raw S3 URLs (type A) to `image.ohousecdn.com`.
 *
 * E.g., https://s3.{region}.amazonaws.com/{bucket}/{path}
 * E.g., https://s3-{region}.amazonaws.com/{bucket}/{path}
 */
createImageUrlMatcher({
  locals: {
    bucket: undefined,
    path: undefined
  },
  test: function test(ctx) {
    var _a, _b;
    // The `region` part in the URL is not important because the image server
    // itself encodes the region corresponding to the bucket name.
    if (!/^s3[-.](?:[^.]+)\.amazonaws.com/.test(ctx.url.hostname)) {
      return false;
    }
    var matches = /*#__PURE__*/_wrapRegExp(/^\/([^/]+)\/(.+)/, {
      bucket: 1,
      path: 2
    }).exec(ctx.url.pathname);
    if (matches == null || ((_a = matches.groups) === null || _a === void 0 ? void 0 : _a['bucket']) == null || ((_b = matches.groups) === null || _b === void 0 ? void 0 : _b['path']) == null) {
      return false;
    }
    ctx.locals.bucket = matches.groups['bucket'];
    ctx.locals.path = matches.groups['path'];
    return true;
  },
  process: function process(ctx) {
    var newUrl = new URL(ctx.url);
    var _ctx$locals2 = ctx.locals,
      bucket = _ctx$locals2.bucket,
      path = _ctx$locals2.path;
    var bucketName = ARCHIVED_LEGACY_BUCKETS.includes(bucket) ? LOCAL_SERVICE_BUCKET : bucket;
    newUrl.hostname = IMAGE_CDN_HOST;
    newUrl.pathname = "/i/".concat(bucketName, "/").concat(path);
    return newUrl;
  }
}),
/**
 * Rewrites raw S3 URLs (type B) or CloudFront edge URLs to `image.ohousecdn.com`.
 *
 * E.g., https://{bucket}.cloudfront.net/*
 * E.g., https://{bucket}.s3.amazonaws.com/*
 * E.g., https://{bucket}.s3.{region}.amazonaws.com/{path}
 * E.g., https://{bucket}.s3-{region}.amazonaws.com/{path} (legacy)
 */
createImageUrlMatcher({
  locals: {
    bucket: undefined
  },
  test: function test(ctx) {
    var _a;
    var matches = /*#__PURE__*/_wrapRegExp(/([^.]+)\.(?:cloudfront.net|s3[-.](?:[^.]+\.)?amazonaws\.com)/, {
      bucket: 1
    }).exec(ctx.url.hostname);
    if (matches == null || ((_a = matches.groups) === null || _a === void 0 ? void 0 : _a['bucket']) == null) {
      return false;
    }
    ctx.locals.bucket = matches.groups['bucket'];
    return true;
  },
  process: function process(ctx) {
    var newUrl = new URL(ctx.url);
    var bucket = ctx.locals.bucket;
    var bucketName = ARCHIVED_LEGACY_BUCKETS.includes(bucket) ? LOCAL_SERVICE_BUCKET : bucket;
    if (!GLOBAL_SERVICE_BUCKETS.includes(bucketName)) {
      // If the bucket is not a global service, rewrite it to the local image server.
      newUrl.hostname = IMAGE_CDN_HOST;
      newUrl.pathname = "/i/".concat(bucketName).concat(ctx.url.pathname);
    } else if (bucketName.includes('qa')) {
      // If the bucket is a QA bucket, rewrite to the custom QA CDN.
      // Allegedly, this CDN is supposed to be used for video thumbnails.
      newUrl.hostname = "qa-".concat(IMAGE_CDN_HOST);
      newUrl.pathname = "/".concat(bucketName).concat(ctx.url.pathname);
    } else {
      // Otherwise, rewrite to the normal cdn.
      newUrl.hostname = IMAGE_CDN_HOST;
      newUrl.pathname = "/".concat(bucketName).concat(ctx.url.pathname);
    }
    return newUrl;
  }
})];
/**
 * Normalizes the given image url and returns the transformed image URL.
 *
 * Note that this will preserve the existing query parameters in the URL if not
 * otherwise specified.
 *
 * @param src The image URL to transform.
 * @param onFinalize An optional callback to modify the final URL.
 * @returns The transformed image URL.
 */
function getCanonicalImageUrl(
// Some image URLs can be undefined or null for many reasons, so we allow
// those values to be passed as well.
src, onFinalize) {
  if (src == null) {
    // If the src is null or undefined, return an empty string.
    return '';
  }
  var _iterator = _createForOfIteratorHelper(MATCHER_RULES),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var rule = _step.value;
      var locals = _objectSpread2({}, rule.locals);
      // Adding a dummy protocol to avoid parsing errors.
      var url = new URL(src, 'https://_');
      var ctx = {
        src: src,
        url: url,
        isRelativeUrl: isRelativeUrl(src),
        locals: locals
      };
      var shouldProcess = rule.test(ctx);
      if (!shouldProcess) {
        continue;
      }
      var res = rule.process(ctx);
      // If the result is a string, return it as-is.
      if (typeof res === 'string') {
        return res;
      }
      // If the `onFinalize` callback is provided, apply it to the result.
      if (!rule.skipFinalize && onFinalize != null) {
        var finalized = onFinalize(res);
        return finalized.toString();
      }
      return res.toString();
    }
    // If no rule is matched, return the original URL as-is.
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return src;
}
function isRelativeUrl(input) {
  return input.startsWith('/');
}

/**
 * Normalizes the given image params and returns the transformed image URL.
 *
 * @param imageOptions The image options to transform.
 * @returns The transformed image URL.
 */
function getImageUrl(imageOptions) {
  return getCanonicalImageUrl(imageOptions.src, function (url) {
    var params = buildCdnOptionsParams(imageOptions);
    var _iterator = _createForOfIteratorHelper(url.searchParams.entries()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];
        // Do not override existing search params except the missing ones.
        if (!params.has(key)) {
          params.append(key, value);
        }
      }
      // This will reconstruct the URL with the new search params.
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    url.search = params.toString();
    return url;
  });
}
function buildCdnOptionsParams(_ref) {
  var width = _ref.width,
    height = _ref.height,
    mode = _ref.mode,
    quality = _ref.quality;
  var params = new URLSearchParams();
  if (width != null) {
    params.set('w', String(width));
  }
  if (height != null) {
    params.set('h', String(height));
  }
  if (mode != null) {
    params.set('c', String(mode[0]));
  }
  if (quality != null) {
    params.set('q', String(quality));
  }
  return params;
}

var getImageSrcSet = function getImageSrcSet(imageOptions, ratios) {
  return ratios.map(function (ratio) {
    return "".concat(getImageUrl(_objectSpread2(_objectSpread2(_objectSpread2({}, imageOptions), imageOptions.width && {
      width: imageOptions.width * ratio
    }), imageOptions.height && {
      height: imageOptions.height * ratio
    })), " ").concat(ratio, "x");
  }).join(',');
};

var IMAGE_SIZES = [36, 72, 144, 180, 256, 360, 480, 512, 640, 720, 850, 960, 1024, 1280, 1360, 1440, 1536, 1700, 1920, 2048, 2560];
function getNearestSize(originSize) {
  var _a;
  return (_a = IMAGE_SIZES.find(function (size) {
    return size >= originSize;
  })) !== null && _a !== void 0 ? _a : IMAGE_SIZES[IMAGE_SIZES.length - 1];
}

var calcImageSize = function calcImageSize(_ref) {
  var width = _ref.width,
    height = _ref.height,
    aspect = _ref.aspect;
  if (height) {
    var nearestHeight = getNearestSize(height);
    return _objectSpread2({
      height: nearestHeight
    }, aspect && {
      width: Math.ceil(nearestHeight * aspect)
    });
  }
  var nearestWidth = getNearestSize(width);
  return _objectSpread2({
    width: nearestWidth
  }, aspect && {
    height: Math.ceil(nearestWidth / aspect)
  });
};

var APP_BANNER_PATHNAME_BLACKLIST = /^\/normal_users|^\/sessions|^\/orders|^\/contacts|^\/exhibitions|^\/cart|^\/3d_intro|^\/interior3ds|^\/payment_personal_info/;
var APP_BANNER_SEARCH_BLACKLIST = /utm_source=(naver_shop|naver_shop_organic|kakao_shop|enuri_shop|danawa_shop)|no_app_banner=true/;

function isOpenAppDownloadBanner(location) {
  return isMobile() && !isHiddenAppDownloadBanner(location) && getCookie('ohsAppDownloadPopupClosed') !== 'yes' && !isHiddenMarketingBanner(location.search);
}
/**
 * 앱 다운로드 배너를 숨길지 여부를 판단합니다.
 * @param location 현재 위치
 * @returns 앱 다운로드 배너를 숨길지 여부
 */
function isHiddenAppDownloadBanner(location) {
  return isInApp() || APP_BANNER_PATHNAME_BLACKLIST.test(location.pathname) || APP_BANNER_SEARCH_BLACKLIST.test(location.search);
}
/**
 * 마케팅 관련 배너를 숨길지 여부를 판단합니다.
 * @param search 현재 위치
 * @returns 마케팅 관련 배너를 숨길지 여부
 */
function isHiddenMarketingBanner(search) {
  var triggered = false;
  try {
    triggered = sessionStorage.marketingHiddenTriggered === 'yes';
  } catch (e) {
    //
  }
  var searchObj = parse(search.slice(1));
  if (triggered || searchObj.pro_app != null) {
    try {
      sessionStorage.marketingHiddenTriggered = 'yes';
    } catch (e) {
      //
    }
    return true;
  }
  return false;
}

export { APP_BANNER_PATHNAME_BLACKLIST as A, getCanonicalImageUrl as a, getImageUrl as b, getImageSrcSet as c, getNearestSize as d, calcImageSize as e, isOpenAppDownloadBanner as f, getDeviceInfo as g, isHiddenAppDownloadBanner as h, isHigherAppVersion as i, isHiddenMarketingBanner as j, getCookie as k, isMobile as l, isInApp as m, APP_BANNER_SEARCH_BLACKLIST as n, setCookie as s };
//# sourceMappingURL=utils.js.map
